import React from 'react';
import './Evidence.css';

const redFlags = [
  { icon: '🔴', title: 'Aucune adresse physique vérifiable', desc: 'L\'adresse indiquée dans les CGV est fictive ou appartient à une société écran basée dans un paradis fiscal.' },
  { icon: '🔴', title: 'CGV rédigées pour piéger', desc: 'Les conditions générales utilisent des dark patterns : cases pré-cochées, refus camouflé, abonnement activé par défaut.' },
  { icon: '🔴', title: 'Service client fantôme', desc: 'Le support ne répond qu\'avec des messages automatiques en anglais. Aucun numéro de téléphone français disponible.' },
  { icon: '🔴', title: 'Domaine récent et suspect', desc: 'Le domaine jumpvendor.com a été enregistré récemment. Un domaine légitime a généralement plusieurs années d\'historique.' },
  { icon: '🔴', title: 'Aucun avis Google/Trustpilot authentique', desc: 'Les quelques avis positifs sont visiblement fake (profils vides, même formulation, même date de création).' },
  { icon: '🔴', title: 'SSL présent mais trompeur', desc: 'Le cadenas HTTPS signifie juste que la connexion est chiffrée — pas que le site est légitime. Erreur classique des victimes.' },
  { icon: '🔴', title: 'Prélèvements fragmentés', desc: 'La stratégie de diviser les prélèvements sur plusieurs jours vise à éviter les alertes bancaires automatiques.' },
  { icon: '🔴', title: 'Produits copiés d\'autres sites', desc: 'Les photos et descriptions de produits sont volées à de vraies boutiques. Aucun produit original n\'existe.' },
];

export default function Evidence() {
  return (
    <section className="evidence section" id="preuves" aria-labelledby="evidence-title">
      <div className="container">
        <span className="tag">Preuves & Red Flags</span>
        <h2 id="evidence-title" className="section-title" style={{ color: 'var(--red-bright)' }}>
          8 Signaux d'Alarme Identifiés
        </h2>
        <p className="section-subtitle">
          Ces caractéristiques correspondent au profil type d'un site frauduleux selon les critères de la DGCCRF et de Signal Spam.
        </p>

        <div className="evidence__grid">
          {redFlags.map((flag, i) => (
            <div key={i} className="evidence__card" role="article">
              <div className="evidence__card-icon">{flag.icon}</div>
              <div>
                <div className="evidence__card-title">{flag.title}</div>
                <div className="evidence__card-desc">{flag.desc}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="evidence__verdict">
          <div className="evidence__verdict-icon">⚖️</div>
          <div className="evidence__verdict-content">
            <h3>Verdict juridique</h3>
            <p>
              Les pratiques décrites constituent des infractions caractérisées au droit français :
              <strong> escroquerie</strong> (Art. 313-1 CP), <strong>pratiques commerciales trompeuses</strong>
              (Art. L.121-2 Code de la consommation) et <strong>abus de faiblesse</strong> (Art. L.121-8).
              Ces infractions sont passibles de <strong>5 ans d'emprisonnement et 375 000€ d'amende.</strong>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
